import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

import {
    TPurchaseReturnDetailsResponse,
    useGetPurchaseReturnByIdQuery,
} from '@/features/slice/purchase-return';

export type PurchaseReturnDetailsContext = {
    id: string;
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
    data?: TPurchaseReturnDetailsResponse;
    error: unknown;
};

const PurchaseReturnDetailsContext =
    createContext<PurchaseReturnDetailsContext | null>(null);

export const PurchaseReturnDetailsProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const params = useParams();
    const id = params.id as string;

    const { data, isLoading, isError, isFetching, error } =
        useGetPurchaseReturnByIdQuery(id);

    return (
        <PurchaseReturnDetailsContext.Provider
            value={{
                id,
                data,
                isLoading,
                isError,
                isFetching,
                error,
            }}
        >
            {children}
        </PurchaseReturnDetailsContext.Provider>
    );
};

export const usePurchaseReturnDetailsContext = () => {
    const context = useContext(PurchaseReturnDetailsContext);
    if (!context) {
        throw new Error(
            'usePurchaseReturnDetailsContext must be used within a PurchaseReturnDetailsProvider',
        );
    }
    return context;
};
